import type { ComponentMultiStyleConfig } from "@chakra-ui/react";

const activeLabelStyles = {
	transform: "translateY(-20px)",
	transitionDuration: "0.2s",
	transitionTimingFunction: "ease-in-out",
};

export const Form: ComponentMultiStyleConfig = {
	parts: ["container", "label"], // Declare as partes na raiz do tema
	variants: {
		floating: {
			container: {
				"position": "relative",
				"_focusWithin": {
					label: {
						...activeLabelStyles,
					},
				},
				"input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label":
          {
          	...activeLabelStyles,
          },
			},
			label: {
				top: "30px",
				left: 0,
				zIndex: 2,
				position: "absolute",
				backgroundColor: "transparent",
				pointerEvents: "none",
				mx: 2,
				px: 2,
				mb: 2,
				transformOrigin: "left top",
			},
		},
	},
};
